module.exports = __webpack_public_path__ + "static/profile-pic.c51b1e8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile-pic.jpg
// module id = 59
// module chunks = 35783957827783 94533468323174 107818501498521